import React, { useState } from 'react';
import { Upload, Modal, Button, Select, Tooltip, Icon, Form, Input, DatePicker, Layout, Space, message, ConfigProvider, Table  } from 'antd';
import SoundMeter from './soundmeter';
import PropTypes from 'prop-types';
import SettingsIcon from "mdi-react/SettingsIcon";
import "../../styles/css/setting.scss";
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios'
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
//视频
import { FileSearchOutlined} from '@ant-design/icons';
let video;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const { Header, Content, Sider } = Layout;
const { Search } = Input;
const closeMediaStream = function (stream) {

    if (!stream) {
        return;
    }
    if (MediaStreamTrack && MediaStreamTrack.prototype && MediaStreamTrack.prototype.stop) {
        var tracks, i, len;

        if (stream.getTracks) {
            tracks = stream.getTracks();
            for (i = 0, len = tracks.length; i < len; i += 1) {
                tracks[i].stop();
            }
        } else {
            tracks = stream.getAudioTracks();
            for (i = 0, len = tracks.length; i < len; i += 1) {
                tracks[i].stop();
            }

            tracks = stream.getVideoTracks();
            for (i = 0, len = tracks.length; i < len; i += 1) {
                tracks[i].stop();
            }
        }
        // Deprecated by the spec, but still in use.
    } else if (typeof stream.stop === 'function') {
        console.log('closeMediaStream() | calling stop() on the MediaStream');
        stream.stop();
    }
}

// Attach a media stream to an element.
const attachMediaStream = function (element, stream) {
    element.srcObject = stream;
};

export default class Doctor extends React.Component {

    constructor(props) {



        super(props)
        let settings = props.settings;
        this.state = {
            startTime:"",
            endTime:"",

            reportData: [],
            loading: true,
            page: 1,
            pageSize: 10,
            total: 0,
            selRoomName: "",
            numberOfPages: "",


            streams: [],
            tex: "2qq",
            id: '',
            imageUrl1: '',
            imageUrl2: '',
            pathologyNumber: '',
            patientName: '',
            patientSex: '',
            patientAge: '',
            outpatientNumber: '',
            bedNumber: '',
            inspectionDepartment: '',
            clinicDiagnosis: '',
            inspectionDoctor: '',
            grossExamination: '',
            microscopeSee: '',
            pathologicDiagnosis: '',
            formData: {},
            visible: true,
            videoDevices: [],
            audioDevices: [],
            audioOutputDevices: [],
            resolution: settings.resolution,
            bandwidth: settings.bandwidth,
            selectedAudioDevice: settings.selectedAudioDevice,
            selectedVideoDevice: settings.selectedVideoDevice,
            selectedVideoDeviceLocal: settings.selectedVideoDeviceLocal,
            codec: settings.codec,
            searchTerm: '',
            setSearchTerm: ''
        }
        this.timerID2 = null; // 存储定时器ID
        try {
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            window.audioContext = new AudioContext();
        } catch (e) {
            console.log('Web Audio API not supported.');
        }
        let fileList = []
        const { imgs } = this.props
        if (imgs && imgs.length > 0) {
            fileList = imgs.map((img, index) => ({
                uid: -index,
                name: img,
                status: 'done',
                url: BASE_IMG_URL + img
            }))
        }
    }



    componentDidMount() {
       
       
    }
    updateInputDevices = () => {
        return new Promise((pResolve, pReject) => {
            let videoDevices = [];
            let audioDevices = [];
            let audioOutputDevices = [];
            navigator.mediaDevices.enumerateDevices()
                .then((devices) => {
                    for (let device of devices) {
                        if (device.kind === 'videoinput') {
                            videoDevices.push(device);
                        } else if (device.kind === 'audioinput') {
                            audioDevices.push(device);
                        } else if (device.kind === 'audiooutput') {
                            audioOutputDevices.push(device);
                        }
                    }
                }).then(() => {
                    let data = { videoDevices, audioDevices, audioOutputDevices };
                    pResolve(data);
                });
        });
    }


    //获取视频成功
    handleSuccess = (stream) => {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
        window.stream = stream;
        //将视频源指定为视频流
        video.srcObject = stream;
    }
    //错误处理
    handleError(error) {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
    }
    soundMeterProcess = () => {
        var val = (window.soundMeter.instant.toFixed(2) * 348) + 1;
        this.setState({ audioLevel: val });
        if (this.state.visible)
            setTimeout(this.soundMeterProcess, 100);
    }
    soundMeterProcess2 = () => {
        var val = (window.soundMeter.instant.toFixed(2) * 348) + 1;
        this.setState({ audioLevel: val });
        if (this.state.visible)
            setTimeout(this.soundMeterProcess2, 100);
    }
    startPreview = () => {
        if (window.stream) {
            // closeMediaStream(window.stream);
        }
        let videoElement = this.refs['previewVideo'];
        let audioSource = this.state.selectedAudioDevice;
        let videoSource = this.state.selectedVideoDevice;


        sessionStorage.setItem('audioSource', audioSource);
        sessionStorage.setItem('videoSource', videoSource);

        this.soundMeter = window.soundMeter = new SoundMeter(window.audioContext);
        let soundMeterProcess = this.soundMeterProcess;
        let constraints = {
            audio: { deviceId: audioSource ? { exact: audioSource } : undefined },
            video: { deviceId: videoSource ? { exact: videoSource } : undefined }
        };
        navigator.mediaDevices.getUserMedia(constraints)
            .then(function (stream) {
                window.stream = stream; // make stream available to console
                //videoElement.srcObject = stream;
                attachMediaStream(videoElement, stream);
                soundMeter.connectToSource(stream);
                setTimeout(soundMeterProcess, 100);
                // Refresh button list in case labels have become available
                return navigator.mediaDevices.enumerateDevices();
            })
            .then((devces) => { })
            .catch((erro) => { });
    }
    startPreview2 = () => {
        if (window.stream) {
            // closeMediaStream(window.stream);
        }

        let videoElement2 = this.refs['previewVideo2'];
        let videoSource = this.state.selectedVideoDeviceLocal;
        let selectedVideoDeviceLocal = this.state.selectedVideoDeviceLocal;
        sessionStorage.setItem('selectedVideoDeviceLocal', selectedVideoDeviceLocal);
        this.soundMeter = window.soundMeter = new SoundMeter(window.audioContext);
        let soundMeterProcess = this.soundMeterProcess2;
        let constraints = {
            video: { deviceId: videoSource ? { exact: videoSource } : undefined }
        };
        navigator.mediaDevices.getUserMedia(constraints)
            .then(function (stream) {
                window.stream = stream; // make stream available to console
                //videoElement.srcObject = stream;

                attachMediaStream(videoElement2, stream);
                soundMeter.connectToSource(stream);
                setTimeout(soundMeterProcess, 100);
                // Refresh button list in case labels have become available
                return navigator.mediaDevices.enumerateDevices();
            })
            .then((devces) => { })
            .catch((erro) => { });
    }
    stopPreview = () => {
        if (window.stream) {
            closeMediaStream(window.stream);
        }
    }

    componentWillUnmount() {

    }

    showModal = () => {

        this.setState({
            visible: true,reportData:[],total:0,page:1
        });

       
        setTimeout(this.startPreview, 100);
        setTimeout(this.startPreview2, 100);


    }

    handleOk = (e) => {

        this.setState({
            visible: false,
        });



    }


    // handleCancel = (e) => {
    //     this.setState({
    //         visible: false,
    //     });
    //     this.stopPreview();
    // }

    // handleAudioDeviceChange = (e) => {
    //     this.setState({ selectedAudioDevice: e });
    //     setTimeout(this.startPreview, 100);
    // }

    handleVideoDeviceChange = (e) => {
        this.setState({ selectedVideoDevice: e });
        setTimeout(this.startPreview, 100);
    }
    handleVideoDeviceLocalChange = (e) => {
        this.setState({ selectedVideoDeviceLocal: e });
        setTimeout(this.startPreview2, 100);
    }
    handleResolutionChange = (e) => {
        this.setState({ resolution: e });
    }

    handleVideoCodeChange = (e) => {
        this.setState({ codec: e });
    }

    handleBandWidthChange = (e) => {
        this.setState({ bandwidth: e });
    }
    onFinish = (values) => {
        console.log('Received values from form:', values);
        // 在这里可以对表单提交的值进行处理，比如发送给后端处理
    };
    handleInputChange1 = (values) => {
        console.log('Received values from form:', values);
        // 在这里可以对表单提交的值进行处理，比如发送给后端处理
    };
    handleSearch = (values) => {
        console.log('Received values from form:', values);
        // 在这里可以对表单提交的值进行处理，比如发送给后端处理
    };


    getImgs = () => {
        return this.state.fileList.map(file => file.name)
    }

    handleCancel = () => {
        this.handleSubmit()
        this.setState({
            visible: false,
        });
    }

    //截屏处理
    takeSnap1 = async (e) => {
        this.props.getImage();
        this.setState({
            imageUrl1: sessionStorage.getItem("base64Image")
        });
    }
    //截屏处理
    takeSnap2 = async (e) => {
        this.props.getImage();
        this.setState({
            imageUrl2: sessionStorage.getItem("base64Image")
        });
    }
    handleChange = () => {

    }
    handledy = (event) => {
        event.preventDefault();
        const printableContent = document.getElementById("myPrintableContent").innerHTML;
        const printWindow = window.open("", "Print");
        printWindow.document.write(`<html><head><title>诊断报告</title> <style> hr {      border: none;      border-top: 3px solid black;      margin: 20px 0; }p { word-wrap: break-word;  word-break: break-all;  white-space: pre-wrap; } </style></head><body>${printableContent}</body></html>`);
        printWindow.document.close();
        printWindow.print();
    }
    handleSubmit = () => {
        console.log("提交")
        const api = axios.create({
            baseURL: 'https://xyreport.xytechsz.com/report'

            // baseURL: 'http://127.0.0.1:5011'
        });

        api.post('/report/sendReport', {

            id: this.state.id,
            pathologicalImage1: this.state.imageUrl1,
            pathologicalImage2: this.state.imageUrl2,
            pathologyNumber: this.state.pathologyNumber,
            patientName: this.state.patientName,
            patientSex: this.state.patientSex,
            patientAge: this.state.patientAge,
            outpatientNumber: this.state.outpatientNumber,
            bedNumber: this.state.bedNumber,
            inspectionDepartment: this.state.inspectionDepartment,
            clinicDiagnosis: this.state.clinicDiagnosis,
            inspectionDoctor: this.state.inspectionDoctor,
            grossExamination: this.state.grossExamination,
            microscopeSee: this.state.microscopeSee,
            pathologicDiagnosis: this.state.pathologicDiagnosis,
            roomName: sessionStorage.getItem('roomName'),
            reportTime: this.state.reportTime?.trim() ?this.state.reportTime:null,
            inspectionTime: this.state.inspectionTime?.trim() ?this.state.inspectionTime:null,

        })
            .then(response => {
                // 处理请求成功的逻辑

                message.success('上传成功', 2);

                


            })
            .catch(error => {
                // 处理请求失败的逻辑
                
                console.error(error);
            });

            this.setState({
                visible: false,
            });   

    }

    handleTxt = (e) => {
        this.setState({ tex: e.target.value })

    }
    pathologyNumberonChange = (e) => {
        this.setState({ pathologyNumber: e.target.value })

    }
    patientNameonChange = (e) => {
        this.setState({ patientName: e.target.value })

    }
    patientSexonChange = (e) => {
        this.setState({ patientSex: e.target.value })

    }
    patientAgeonChange = (e) => {
        this.setState({ patientAge: e.target.value })

    }
    outpatientNumberonChange = (e) => {
        this.setState({ outpatientNumber: e.target.value })

    }
    bedNumberonChange = (e) => {
        this.setState({ bedNumber: e.target.value })

    }
    inspectionDepartmentonChange = (e) => {
        this.setState({ inspectionDepartment: e.target.value })

    }
    clinicDiagnosisonChange = (e) => {
        this.setState({ clinicDiagnosis: e.target.value })

    }
    inspectionDoctoronChange = (e) => {
        this.setState({ inspectionDoctor: e.target.value })

    }
    grossExaminationonChange = (e) => {
        this.setState({ grossExamination: e.target.value })

    }
    microscopeSeeonChange = (e) => {
        this.setState({ microscopeSee: e.target.value })

    }
    pathologicDiagnosisonChange = (e) => {
        this.setState({ pathologicDiagnosis: e.target.value })

    }
    selRoomNameOnChange = (e) => {
        this.setState({ selRoomName: e.target.value })

    }
    selectOnClick = (e) => {
        this.fetchData()
    }
    addReport = (e) => {
        this.setState({ id: "" });
        this.setState({ imageUrl1: "" });
        this.setState({ imageUrl2: "" });
        this.setState({ pathologyNumber: "" });
        this.setState({ patientName: "" });
        this.setState({ patientSex: "" });
        this.setState({ patientAge: "" });
        this.setState({ outpatientNumber: "" });
        this.setState({ bedNumber: "" });
        this.setState({ inspectionDepartment: "" });
        this.setState({ clinicDiagnosis: "" });
        this.setState({ inspectionDepartment: "" });
        this.setState({ clinicDiagnosis: "" });
        this.setState({ inspectionDoctor: "" });
        this.setState({ bedNumber: "" });
        this.setState({ grossExamination: "" });
        this.setState({ microscopeSee: "" });
        this.setState({ pathologicDiagnosis: "" });
        this.setState({ reportTime: "" });
        this.setState({ inspectionTime: "" });

    }
    handleReportTimeChange = (date) => {
        this.setState({ reportTime: date.format('YYYY-MM-DD HH:mm:ss') });
    }
    handleInspectionTimeTimeChange = (date) => {
        this.setState({ inspectionTime: date.format('YYYY-MM-DD HH:mm:ss') });

    }

    fetchData = () => {
        const { page, pageSize, selRoomName,startTime,endTime } = this.state;
        this.setState({ loading: true });
          console.log(startTime)  
          console.log(endTime)  
        const api = axios.create({
            // baseURL: 'http://127.0.0.1:5011'
            baseURL: 'https://xyreport.xytechsz.com/report'
        });
        api.get('/report/selectPage', {
            params: {
                startTime: startTime ,
                endTime:endTime,
                pathologyNumber: "",
                patientName: "",
                pageSize: pageSize,
                pageNum: page,
                roomName: selRoomName
            }
        })
            .then(response => {
                // 处理请求成功的逻辑

                this.setState({ reportData: response.data.data.list, loading: false, total: response.data.data.total, numberOfPages: Math.ceil(response.data.data.total / pageSize) });




                // this.setState({ inspectionTime: response.data.data.inspectionTime });

            })
            .catch(error => {
                // 处理请求失败的逻辑
                console.error(error);
            });

        // const newData = Array.from({ length: pageSize }).map((_, index) => {
        //     const id = (page - 1) * pageSize + index + 1;
        //     return { id, name: `Item ${id}` };
        // });
        // this.setState({ data: newData, loading: false, total: 100 }); // 假设总共有100条记录
    };

    handleTableChange = (pagination) => {
        this.setState({ page: pagination.current, pageSize: pagination.pageSize }, () => {

            this.fetchData();
        });
    };
    handlePrevPage = () => {
        const { page } = this.state;
        if (page > 1) {
            this.setState({ page: page - 1 }, () => {

                this.fetchData();
            });
        }
    };

    handleNextPage = () => {
        const { page } = this.state;
        if (page < this.state.numberOfPages) {
            this.setState({ page: page + 1 }, () => {
                this.setState({ page: page + 1 })

                this.fetchData();
            });
        }
    };
    changeRoomId = (e) => {
        const api = axios.create({
            // baseURL: 'http://127.0.0.1:5011'
            baseURL: 'https://xyreport.xytechsz.com/report'

            
        });

        api.post('/report/changeRoomId', {
            roomName: sessionStorage.getItem('roomName'),
            patientId: e

        })
            .then(response => {
                // 处理请求成功的逻辑


               


            })
            .catch(error => {
                // 处理请求失败的逻辑
                console.error(error);
            });
    };

    changeRangePicker = (value, dateString) => {
        const [startTime, endTime] = dateString;
        this.setState({startTime:startTime,endTime:endTime})
     
       
    };
    onOkRangePicker = (e) => {
        console.log(e)
       
    };

   
    render() {
        const { reportData, loading, page, pageSize, total } = this.state;


        return (
            <div>
			
                {
					  <p	onClick={this.showModal}>注册</p>
                      
                  
                }
                <Modal
                    title='注册'
                    visible={this.state.visible}
                    onCancel={this.handleCancel}

                    width="80%"
                    className="full-modal"
                    footer={[

                        <Button key='continue' onClick={this.handledy}>取消</Button>,
                        <Button key='Submit' onClick={this.handleSubmit}>确定</Button>,

                    ]}

                >
                    <div style={{ display: 'none' }}>
                        <div id="myPrintableContent" className="report-container">
                            <h2 style={{ textAlign: 'center' }}>医院诊断报告单</h2>

                            <div className="patient-info">
                                <span >病理号: </span>
                                <span >{this.state.pathologyNumber}</span>

                                <hr />
                                
                                <hr style={{ borderTop: '1px solid black' }} />
                            </div>
                            <div className="diagnosis">
                                <h3>病理图像：</h3>

                                <img width="200px" src={this.state.imageUrl1} alt={`病理图像1`} />
                                <img style={{ marginLeft: '20px' }} width="200px" src={this.state.imageUrl2} alt={`病理图像2`} />

                                <h4>大体检查：</h4>
                                <p>{this.state.grossExamination}</p>
                                <h4 style={{ marginTop: '80px' }}>镜下所见：</h4>
                                <p >{this.state.microscopeSee}</p>
                                <h4 style={{ marginTop: '80px' }}>病理诊断：</h4>
                                <p >{this.state.pathologicDiagnosis}</p>
                            </div>

                        </div>
                    </div>

                    <Layout>

                        <Layout>

                            <Layout>
                                <Content style={{ padding: '24px' }}>
                                    <Form layout="vertical">
                                      
                                        <Form.Item style={{ marginTop: "100px", }} label="大体检查" name="diagnosis" rules={[{ required: true, message: '请输入诊断信息' }]}>
                                            <Input.TextArea value={this.state.grossExamination} onChange={this.grossExaminationonChange} placeholder="请输入诊断信息" rows={8} />
                                        </Form.Item>
                                        <Form.Item label="镜下所见" name="diagnosis" rules={[{ required: true, message: '请输入诊断信息' }]}>
                                            <Input.TextArea value={this.state.microscopeSee} onChange={this.microscopeSeeonChange} placeholder="请输入诊断信息" rows={8} />
                                        </Form.Item>
                                        <Form.Item label="病理诊断" name="diagnosis" rules={[{ required: true, message: '请输入病理诊断信息' }]}>
                                            <Input.TextArea value={this.state.pathologicDiagnosis} onChange={this.pathologicDiagnosisonChange} placeholder="请输入病理诊断" rows={8} />
                                        </Form.Item>

                                    </Form>
                                </Content>
                            </Layout>
                        </Layout>
                    </Layout>



                </Modal>
            </div>
        );
    }
}


Doctor.propTypes = {
    onMediaSettingsChanged: PropTypes.func
}


